import React from 'react';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

import { useTableContext } from '../../contexts';
import { BodyCell } from '../BodyCell';

import styles from './TableBodySection.module.scss';

export interface ITableBodySectionProps {}

export const TableBodySection: React.FC<ITableBodySectionProps> = () => {
    const {
        getRowModel,
        props: { rowStyle, onRowClick, rowLink, dense },
    } = useTableContext();

    return (
        <tbody className={classNames(styles.tableBody)}>
            {getRowModel().rows.map((row, rowIndex) => {
                const link = rowLink?.(row.original);

                return (
                    <tr
                        key={row.id}
                        onClick={(e) => onRowClick?.(row.original, e)}
                        className={classNames(styles.tableBodyRow, {
                            [styles.clickable]: !!onRowClick || link !== undefined,
                        })}
                        style={rowStyle?.(row.original)}
                    >
                        {row.getVisibleCells().map((cell) => (
                            <BodyCell
                                key={cell.id}
                                cell={cell}
                                lastRow={getRowModel().rows.length - 1 === rowIndex}
                                dense={dense}
                                rowLink={link}
                            >
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </BodyCell>
                        ))}
                    </tr>
                );
            })}
        </tbody>
    );
};
